import { useEffect } from "react";
import { useDispatch } from "react-redux";
import ReportCustomerDiscountMain from "../../../features/report/report-customer-discount/component/ReportCustomerDiscountMain";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";

const title = "Report Customer Discount";

const ReportCustomerDiscountPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <ReportCustomerDiscountMain />;
};

export default ReportCustomerDiscountPage;
